import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { getSelectValue } from "../utils/selectHelpers";

const getSingleValue = (options, value) => {
  if (value === "" || value === null || value === undefined) return null;
  return options.find((opt) => String(opt.value) === String(value)) || null;
};

const customSelectStyles = (isInvalid = false) => ({
  control: (base) => ({
    ...base,
    minHeight: "38px",
    borderColor: isInvalid ? "#dc3545 !important" : base.borderColor,
    "&:hover": {
      borderColor: isInvalid ? "#dc3545 !important" : base.borderColor,
    },
  }),
});

const FormSelectField = ({
  label,
  name,
  value,
  options = [],
  isMulti = false,
  isRequired = false,
  error = "",
  placeholder = "Select...",
  onChange,
  colClass = "col-md-4",
}) => {
  const handleChange = (selected) => {
    if (isMulti) {
      const values = selected ? selected.map((opt) => opt.value) : [];
      onChange(name, values);
    } else {
      onChange(name, selected ? selected.value : "");
    }
  };

  const selectedValue = isMulti
    ? getSelectValue(options, value)
    : getSingleValue(options, value);

  return (
    <div className={colClass}>
      <label className="form-label">
        {label} {isRequired && <span className="text-danger">*</span>}
      </label>
      <Select
        isMulti={isMulti}
        options={options}
        value={selectedValue}
        onChange={handleChange}
        placeholder={placeholder}
        styles={customSelectStyles(Boolean(error))}
        classNamePrefix="react-select"
        className={error ? "is-invalid" : ""}
        menuPlacement="auto"
        menuPortalTarget={document.body}
      />
      {error && <div className="invalid-feedback text-start d-block">{error}</div>}
    </div>
  );
};

FormSelectField.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  options: PropTypes.array,
  isMulti: PropTypes.bool,
  isRequired: PropTypes.bool,
  error: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  colClass: PropTypes.string,
};

export default React.memo(FormSelectField);